module.exports = __webpack_public_path__ + "img/product-order-2.ea322fde.jpg";